import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 90,
      sortable: true,
    },
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      minWidth: 80,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'minimum',
      label: i18n.t('labor.minimum_time'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'maximum',
      label: i18n.t('labor.maximum_time'),
      minWidth: 100,
      sortable: true,
      align: 'center',

    },
    {
      prop: 'approval',
      label: i18n.t('labor.approval'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'description',
      label: i18n.t('common_words.description'),
      minWidth: 100,
      sortable: true,
    },
  ];

  return { Table };
};

export default configTable;
